import { SimpleSignal } from "../utils/SimpleSignal";

export class SignalConfig<T>
{
	public value: T;
	public min: T;
	public max: T;

	public signal: SimpleSignal;

	constructor(config: {value: T; min?: T; max?: T})
	{
		this.value = config.value;
		if (config.min !== undefined) this.min = config.min;
		if (config.max !== undefined) this.max = config.max;

		this.signal = new SimpleSignal();
	}

	public setValue(value:T, checkChange = false)
	{
		if (checkChange === false || this.value !== value)
		{
			this.value = value;
			this.signal.dispatch(value);
		}
	}
}